import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  drawerOpen: false, // 💡 Keep it simple! Only track visual UI states.
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    toggleCartDrawer: (state) => {
      state.drawerOpen = !state.drawerOpen;
    },
    setCartDrawer: (state, action) => {
      state.drawerOpen = action.payload;
    },
  },
});

export const { toggleCartDrawer, setCartDrawer } = cartSlice.actions;
export default cartSlice.reducer;

